// src/features/user/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null, // Initial user data (can be null or an empty object)
  isAuthenticated: false, // Whether the user is authenticated or not
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload; // Set the user data
      state.isAuthenticated = true; // Set authenticated to true
    },
    logout: (state) => {
      state.user = null; // Clear user data
      state.isAuthenticated = false; // Set authenticated to false
    },
  },
});

export const { setUser, logout } = userSlice.actions;
export default userSlice.reducer;
